import { Model } from '@vuex-orm/core';
import { Warehouse, Product } from './models';
import { uuidv4 } from '../../utils/helpers';

export class Stock extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'stock';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      warehouse_id: this.attr(null),
      warehouse: this.belongsTo(Warehouse, 'warehouse_id'),
      product_id: this.attr(null),
      product: this.belongsTo(Product, 'product_id'),
      quantity: this.attr(null),
      value: this.attr(null),
    };
  }
}

export default Stock;
